import { ContentType } from '@/@types/common'
import type { PostType } from '@/@types/post'

export enum PostRouteType {
	POST = 'post',
	REPOST = 'repost',
}
export type PostRouteTypeMap = Record<PostType, PostRouteType>
export const POST_TYPE_TO_ROUTE_MAPPING: PostRouteTypeMap = {
	ORIGINAL_POST: PostRouteType.POST,
	REPOST: PostRouteType.REPOST,

	//@fixme personal update 不一定是 post
	PERSONAL_UPDATE: PostRouteType.POST,
}

export function toRoutePathParam(type: PostType): PostRouteTypeMap[keyof PostRouteTypeMap] {
	return POST_TYPE_TO_ROUTE_MAPPING[type]
}

export const ROUTE_TO_POST_TYPE_MAPPING: Record<PostRouteType, PostType> = {
	[PostRouteType.POST]: ContentType.POST,
	[PostRouteType.REPOST]: ContentType.REPOST,
}

export function toPostType(route: PostRouteType): PostType {
	return ROUTE_TO_POST_TYPE_MAPPING[route]
}
